<!-- 缺陷耗时分布 -->
<template>
  <a-card title="缺陷耗时分布" size="small">
    <div id="defecet-take-time" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
import { qualityDefectTakeTime } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: {
        start_date: null,
        end_date: null,
        projects: null
      }
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {},
        yAxis: {},
        series: []
      }
    };
  },
  watch: {
    filterForm() {
      this.getDefectTakeTimeData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    this.myChart = echarts.init(document.getElementById('defecet-take-time'));
    this.getDefectTakeTimeData();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },

    getDefectTakeTimeData() {
      const { code, data, message } = qualityDefectTakeTime(this.filterForm).then(res => {
        this.option.xAxis.data = res.data.x_axis;
        this.option.series = res.data.series.map(defect => {
          return {
            name: defect.name,
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            // stack: 'bug',
            data: defect.data
          };
        });
        this.drawChart();
      });
    }
  }
};
</script>
